import { render, staticRenderFns } from "./ColumnUser.vue?vue&type=template&id=f659ac52"
import script from "./ColumnUser.vue?vue&type=script&lang=js"
export * from "./ColumnUser.vue?vue&type=script&lang=js"
import style0 from "./ColumnUser.vue?vue&type=style&index=0&id=f659ac52&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f659ac52')) {
      api.createRecord('f659ac52', component.options)
    } else {
      api.reload('f659ac52', component.options)
    }
    module.hot.accept("./ColumnUser.vue?vue&type=template&id=f659ac52", function () {
      api.rerender('f659ac52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ColumnUser.vue"
export default component.exports